import {
    getModule,
    Module,
    MutationAction,
    VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { RegisterRequest } from "@/api/corporate-shop/request";
import * as CorporateAPI from "@/api/corporate-shop";
import { isSuccess } from "@/api/response";
import {RegisterResponse} from "@/api/corporate-shop/response";

const MODULE_NAME = "corporate-shop/register";

/**
 * 会社概要情報登録更新API（/regist-corporate）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Register extends VuexModule {
    // state
    registerResponse: RegisterResponse = {} as RegisterResponse;

    // getters
    get isSuccess() {
        return isSuccess(this.registerResponse);
    }

    get getMessage() {
        return this.registerResponse.message;
    }

    get getPreviewUrl() {
        if (this.registerResponse.results) {
            return this.registerResponse.results.previewUrl;
        } else {
            return "";
        }
    }

    // MutationActions
    @MutationAction
    async register(registerRequest: RegisterRequest) {
        const registerResponse = await CorporateAPI.register(registerRequest);
        return {
            registerResponse
        };
    }

    @MutationAction
    async clear() {
        return {
            registerResponse: {} as RegisterResponse
        };
    }
}

export default getModule(Register);
